import {
    ISSUES_STATUSES_INITIALIZE_LIST,
    ISSUES_STATUSES_INITIALIZE_LIST_ERROR,
    ISSUES_STATUSES_INITIALIZE_LIST_SUCCESS,

    ISSUES_STATUSES_DELETE_ITEMS,
    ISSUES_STATUSES_DELETE_ITEMS_ERROR, ISSUES_STATUSES_DELETE_ITEMS_SUCCESS,
    ISSUES_STATUSES_GET_LIST,
    ISSUES_STATUSES_GET_LIST_ERROR,

    ISSUES_STATUSES_GET_LIST_SEARCH, ISSUES_STATUSES_GET_LIST_SUCCESS,
    ISSUES_STATUSES_GET_LIST_WITH_FILTER,
    ISSUES_STATUSES_GET_LIST_WITH_ORDER,
    ISSUES_STATUSES_SELECTED_ITEMS_CHANGE
} from './actions_def';

const INIT_STATE = {
    statuses: [],
    errors: [],
    filter: null,
    searchKeyword: '',
    orderColumns: [
        { column: 'title', label: 'Title' },
        { column: 'status', label: 'IssuesStatus' },
        { column: 'status', label: 'IssuesStatus' },
        { column: 'label', label: 'Label' },
    ],
    isLoading: false,
    isLoaded: false,
    saving: false,
    selectedItems: [],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ISSUES_STATUSES_GET_LIST:
            //console.log(action.payload)
            return {
                ...state,
                isLoading: true,
                isLoaded: false
            };

        case ISSUES_STATUSES_GET_LIST_SUCCESS:
            //console.log(action.payload)
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                statuses: action.payload,
            };

        case ISSUES_STATUSES_GET_LIST_ERROR:
            //console.log(action.payload)
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                error: action.payload
            };

        case ISSUES_STATUSES_GET_LIST_WITH_FILTER:
            if (action.payload.column === '' || action.payload.value === '') {
                return {
                    ...state,
                    isLoading: false,
                    isLoaded: true,
                    statuses: state.allIssuesStatusItems,
                    filter: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const filteredItems = state.allIssuesStatusItems.filter(
                (item) => item[action.payload.column] === action.payload.value
            );
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                statuses: filteredItems,
                filter: {
                    column: action.payload.column,
                    value: action.payload.value,
                },
            };

        case ISSUES_STATUSES_GET_LIST_WITH_ORDER:
            if (action.payload === '') {
                return {
                    ...state,
                    isLoading: false,
                    isLoaded: true,
                    statuses: state.statuses,
                    orderColumn: null,
                };
            }
            // eslint-disable-next-line no-case-declarations
            const sortedItems = state.statuses.sort((a, b) => {
                if (a[action.payload] < b[action.payload]) return -1;
                if (a[action.payload] > b[action.payload]) return 1;
                return 0;
            });
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                statuses: sortedItems,
                orderColumn: state.orderColumns.find(
                    (x) => x.column === action.payload
                ),
            };

        case ISSUES_STATUSES_GET_LIST_SEARCH:
            if (action.payload === '') {
                return { ...state, statuses: state.allIssuesStatusItems };
            }
            // eslint-disable-next-line no-case-declarations
            const keyword = action.payload.toLowerCase();
            // eslint-disable-next-line no-case-declarations
            const searchItems = state.allIssuesStatusItems.filter(
                (item) =>
                    item.title.toLowerCase().indexOf(keyword) > -1 ||
                    item.detail.toLowerCase().indexOf(keyword) > -1 ||
                    item.status.toLowerCase().indexOf(keyword) > -1 ||
                    item.status.toLowerCase().indexOf(keyword) > -1 ||
                    item.label.toLowerCase().indexOf(keyword) > -1
            );
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                statuses: searchItems,
                searchKeyword: action.payload,
            };

        case ISSUES_STATUSES_SELECTED_ITEMS_CHANGE:
            return {
                ...state, isLoading: false,
                isLoaded: true, selectedItems: action.payload
            };

        case ISSUES_STATUSES_DELETE_ITEMS:
            return {
                ...state,
                isLoading: false,
                isLoaded: false,
                saving: true
            };

        case ISSUES_STATUSES_DELETE_ITEMS_SUCCESS:

            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                saving: false,
                saved: true,
                errors: [],
                allIssuesStatusItems: state.allIssuesStatusItems.filter(item => item.id !== action.payload.rfc_id),
                statuses: state.statuses.filter(item => item.id !== action.payload.rfc_id),
            };

        case ISSUES_STATUSES_DELETE_ITEMS_ERROR:
            console.log("Failed", action.payload)
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                saving: false,
                saved: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        case ISSUES_STATUSES_INITIALIZE_LIST:
            console.log("ISSUES_STATUSES_INITIALIZE_LIST", action.payload)
            return {
                ...state,
                isLoading: true,
                isLoaded: false,
                saving: true
            };

        case ISSUES_STATUSES_INITIALIZE_LIST_SUCCESS:
            console.log("STATUSES_INITIALIZE_LIST_SUCCESS", action.payload)
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                errors: [],
                allIssuesStatusItems: action.payload,
                statuses: action.payload,
            };

        case ISSUES_STATUSES_INITIALIZE_LIST_ERROR:
            console.log("STATUSES_INITIALIZE_LIST_ERROR", action.payload)
            return {
                ...state,
                isLoading: false,
                isLoaded: true,
                errors: action.payload.errors.map(error => (
                    {
                        field: error.field,
                        error_code: error.code
                    }
                ))
            };

        default:
            return { ...state };
    }
};
